import CpfInput from './CpfInput';

export default CpfInput;
